import { AiOutlineCheck } from "react-icons/ai";
import Modal from "../components/Modal";
import { Button } from "../components/Button";
import { useState } from "react";
import { MdIncompleteCircle } from "react-icons/md";
import { knowHacces, knowAcces } from "../utils/utils";
import { Memo } from "./Home/Memo";
import { BillingDashboard } from "./Home/BillingDashboard";
import { CedoliniDashboard } from "./Home/CedoliniDashboard";

export const Home = () => {
  const [isOpen, setIsOpen] = useState(true);
  const isAdmin = knowAcces(["admin"]);

  return (
    <div className="page-container grid grid-cols-2 gap-2">
      <div className="el-container col-span-2 md:col-span-1 h-fit">
        <div className="w-full relative flex flex-col  ">
          <div className="flex flex-row justify-start px-3 pt-2">
            <div>
              <h4 className="text-lg font-light text-miller-300 dark:text-slate-100 ">
                Ciao, <span className="font-semibold ">{localStorage.getItem("username")}!</span>
              </h4>
            </div>
          </div>
          <div className="mb-auto flex my-4 w-full items-center justify-center">
            <center>
           
            </center>
          </div>
         
        </div>
      </div>




      <div className="el-container col-span-2 md:col-span-1 h-fit">
        <Memo operazione={"inserimento"}/>
      </div>


      {isAdmin && <BillingDashboard />}
      {knowAcces(["parc_admin", "parc_team_leader"]) && <CedoliniDashboard />}



    </div>
  );
};
{
  /* <Modal
        isOpen={isOpen}
        closeButton={() => setIsOpen(false)}
        headerText="Dettaglio attrezzature"
        rightButtons={
          <>
            <Button
              className="success-button"
              size="md"
              text={"Salva"}
              icon={<AiOutlineCheck className="button-icon" />}
              //onClick={handleSave}
            />
          </>
        }
      ></Modal> */
}
